import { useParams} from "react-router-dom";
import projectData from "../data/projects.json";
import { Link } from "react-router-dom";
import FileManager from "../projects/FileManager";
import ParkChicago from "../projects/ParkChicago";
import SpecialtyCoffee from "../projects/SpecialtyCoffee";

const componentsMap = {
  FileManager,
  ParkChicago,
  SpecialtyCoffee
};

export default function Project() {
  const { slug } = useParams();

  const project = projectData.find(p => p.slug === slug);

  if (!project) {
    return (
      <main className="project-page" role="main">
        <p role="alert">Project not found</p>
      </main>
    );
  }

  const ProjectComponent = project.component
    ? componentsMap[project.component]
    : null;

  return (
    <main
      className="project-page"
      role="main"
      aria-labelledby="project-title"
    >
      <h1 id="project-title" className="sr-only">
        {project.title || "Project details"}
      </h1>

     
        {ProjectComponent ? (
          <ProjectComponent />

        ) : (
          <p>No preview available for this project.</p>
        )}

      <Link
        to="/project"
        className="more-projects"
        aria-label="View more projects"
      >
        More Projects
      </Link>
    </main>
  );
}
